/**
 * Image Module
 * 
 * Adds a CSS class to images that are lazy-loaded.
 * 
 * Important: make sure the 'no-js' class is removed from the body.
 * This currently happens in the main.js file.
 */

const Image = {
    init() {
        this.addStyles();
        this.handleImages();
        this.setupObserver();
    },

    addStyles() {
        const style = document.createElement('style');
        style.textContent = `
            body:not(.no-js) img[loading="lazy"] {
                opacity: 0;
                transition: opacity 0.2s ease-in-out;
            }
            body:not(.no-js) img[loading="lazy"].loaded {
                opacity: 1;
            }
        `;
        document.head.appendChild(style);
    },

    handleImage(img) {
        if (img.complete) {
            img.classList.add("loaded");
        } else {
            img.onload = () => {
                img.classList.add("loaded");
            };
            img.onerror = () => {
                console.error(`Failed to load image: ${img.src}`);
            };
        }
    },

    handleImages() {
        document.querySelectorAll("img").forEach(this.handleImage);
    },

    setupObserver() {
        const imageObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.target.querySelectorAll("img")?.forEach(this.handleImage);
            });
        });

        // Start observing the entire document for added nodes
        imageObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
};

export default Image; 